import { computed, type MaybeRefOrGetter } from 'vue'
import { tradingErrorCopy, useSellOverviewQuery } from '../../trading'

// Sell eligibility for one holding, for surfaces outside the sell drawer
// (portfolio's holding page): whether the property trades at all (hide "Sell
// Tokens" when it doesn't), whether these tokens can be listed now, and why
// not — in spec copy. Keyed by PROPERTY id. Same cache as the drawer.
export function useSellEligibility(propertyId: MaybeRefOrGetter<string>) {
  const overviewQuery = useSellOverviewQuery(propertyId)

  const isLoaded = computed(() => Boolean(overviewQuery.data.value))
  const isTradable = computed(() => overviewQuery.data.value?.isTradable ?? false)
  const canSell = computed(() => Boolean(overviewQuery.data.value?.canSell))
  const reasons = computed(() =>
    (overviewQuery.data.value?.ineligibleReasons ?? [])
      .map((code) => tradingErrorCopy(code))
      .filter((copy): copy is string => copy !== null),
  )

  return { isLoaded, isTradable, canSell, reasons }
}
